import React               from 'react';
import { Observe }              from 'rewire-core';
import { UdfsContainerModel }   from '../schedule/UdfsModel';
import DefaultEditPanelFormView from './DefaultEditPanelFormView';
import SettingsModel, { If }    from './SettingsModel';
import UdfEditor                from './UdfEditor';

export default ({ settings }: { settings: SettingsModel }) => {
  return (
    <Observe>{
      () => {
        if (!settings?.editor) return null;
        const Editor    = settings.EditPanelFormView || DefaultEditPanelFormView;
        const udfEditor = (settings.editor as UdfsContainerModel)?.udfEditor;
        return (
          < >
            <If condition={settings.selectedItem} then={<Editor settings={settings} editor={settings.editor} />} />
            <UdfEditor udfEditor={udfEditor} />
          </>
        );
      }}
    </Observe>
  );
};
